import { render, staticRenderFns } from "./elementTextEditor.vue?vue&type=template&id=09a91725&scoped=true&"
import script from "./elementTextEditor.vue?vue&type=script&lang=js&"
export * from "./elementTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./elementTextEditor.vue?vue&type=style&index=0&id=09a91725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a91725",
  null
  
)

export default component.exports